import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class Nav extends React.PureComponent {
    static propTypes = {};

    async componentDidMount() {}

    render() {
        return (
            <div className={styles.navContainer} id="nav">
                <div className="col_w1000 pz">
                    <div className={styles.nav} cmpp-type="s">
                        <a href="//travel.ifeng.com/" target="_blank">
                            首页
                        </a>
                        <span>|</span>
                        <a href="//travel.ifeng.com/shanklist/33-60141-" target="_blank">
                            极致之旅
                        </a>
                        <span>|</span>
                        <a href="//travel.ifeng.com/globalgo/index.shtml" target="_blank">
                            全球GO
                        </a>
                        <span>|</span>
                        <a href="//travel.ifeng.com/shanklist/33-60142-" target="_blank">
                            嗜住
                        </a>
                        <span>|</span>
                        <a href="//travel.ifeng.com/shanklist/33-60139-" target="_blank">
                            凤凰网旅讯
                        </a>
                        <span>|</span>
                        <a href="//travel.ifeng.com/shanklist/33-60148-" target="_blank">
                            业界
                        </a>
                        <span>|</span>
                        <a href="//travel.ifeng.com/shanklist/33-60143-" target="_blank">
                            赏味
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Nav);
